import logoLM from 'assets/img/themes/launchmobility/logo.png';
import favicon from 'assets/img/themes/launchmobility/favicon.png';

export const integrations = {
  apiTargetVersion: '1.74.2',
  stage: process.env.PROD ? 'production' : process.env.REACT_APP_STAGE || 'staging',
  apiUrl: process.env.REACT_APP_API_URL || 'https://api{{env}}.lminc.io/api/v1',
  mcUrl: process.env.REACT_APP_MC_URL || 'https://control{{bastion_slug}}{{env}}.lminc.io',
  deployment: process.env.REACT_APP_DEPLOYMENT || 'development',
  cubeUrl: process.env.REACT_APP_CUBE_URL || 'https://analytics{{env}}.lminc.io',
  cubeUrlRER: process.env.REACT_APP_CUBE_URL_RER,
  cubeUrl2: process.env.REACT_APP_CUBE_URL_2,
  stripe_key: process.env.REACT_APP_STRIPE_KEY,
  sentry: process.env.REACT_APP_SENTRY,
  logging: process.env.REACT_APP_LOGGING,
  zuoraResources: process.env.REACT_APP_ZUORA_RESOURCES,
  zuoraSecurity: process.env.REACT_APP_ZUORA_SECURITY,
  zuoraKey: process.env.REACT_APP_ZUORA_KEY,
  googleMapsUrl: process.env.REACT_APP_GOOGLE_MAPS_URL,
  publicURL: process.env.PUBLIC_URL,
  authServerUrl: process.env.REACT_APP_AUTH_SERVER_URL || 'https://auth-dev.lminc.io',
  ccpURL: process.env.REACT_APP_CCP_URL || 'https://customer-test.lminc.io',
  logo: logoLM,
  documents: {
    tnc: {
      label: 'TNC',
      value: 'tnc_proof',
      active: true,
    },
    dl: {
      label: 'Driver License',
      value: 'driver_license',
      active: true,
    },
  },
  page: {
    title: 'LaunchMobility',
    favicon: favicon,
    support: 'Launch Mobility Support',
  },
  dashboard_settings: {
    noc: {
      timeline: {
        minZoom: 14400000,
        maxZoom: 604800000,
        startDate: {
          time: 'day',
          count: -1,
        },
        endDate: {
          time: 'day',
          count: 1,
        },
        traditionalZoom: true,
        todayMarker: {
          backgroundColor: '#18D198',
        },
      },
    },
    alarms: {
      priority: 'ALL',
      active: true,
      limit: 4,
    },
    tasks: {
      priority: 'ALL',
      status: 'ALLACTIVE',
      limit: 4,
    },
    logs: {
      pageSiz: 20,
    },
    map: {
      defaultZoom: 5,
      centerFallback: {
        lat: 34.0201613,
        lng: -118.6919161,
      },
      options: {
        scrollwheel: false,
      },
    },
  },
};
